enum Lang {
  nl = 'nl',
  fr = 'fr',
  en = 'en',
}

export default Lang;
